import * as yup from 'yup';
import { useAPI } from '@/services/utils';
import { TFormStep } from '@/components/HookForm';
import Toast from '@/components/Toast';
import RestoreForm from './RestoreForm';

export type TFieldValues = {
  code: string;
};

const useRestoreForm = (): TFormStep<TFieldValues> => {
  const { mutateAsync } = useAPI(['card', 'verifyRestoreOTP'], {
    isMutation: true,
  });

  return {
    Component: RestoreForm,
    defaultValues: { code: '' },
    schema: { code: yup.string().required('ورود کد الزامی است') },
    onSubmit: async (values) => {
      await mutateAsync({ code: values.code });
    },
    onSubmitError: (error) => {
      Toast.open({
        children:
          error?.message ||
          'ثبت درخواست شما با مشکل روبرو شد، لطفا دوباره تلاش کنید',
        variant: 'error',
        offsetDirection: 'above',
        hasIcon: false,
      });
    },
  };
};

export default useRestoreForm;
